import { useState } from 'react';
import { Dialog, IconButton, Stack, Typography } from '@mui/material';
import { ChevronLeftOutlined, ChevronRightOutlined, Close } from '@mui/icons-material';
import { ScreenshotsDialogPropsType } from './ScreenshotsDialog.types';
import {
  AlertSnackbar,
  Image,
  ImagePagination,
  convertMillisecondsToSeconds,
  theme,
  timelineLabel,
} from '@shared';
import { API_ROUTES } from 'App';

const { REACT_APP_URL } = process.env;

const arrowStyle = {
  position: 'absolute',
  top: '50%',
  color: theme.palette.grey[300],
  backgroundColor: theme.palette.action.active,
};

export const ScreenshotsDialog = ({
  stream,
  isModalOpen,
  onCloseModal,
  screenshotClocks = [],
}: ScreenshotsDialogPropsType) => {
  const [isError, setIsError] = useState(false);

  const [selectedScreenshot, setSelectedScreenshot] = useState(1);

  const src =
    REACT_APP_URL +
    API_ROUTES.apiV1AuditScreenshot(
      stream.streamHandle,
      screenshotClocks[selectedScreenshot - 1]?.append
    );

  return (
    <Dialog
      fullWidth
      sx={{
        '.MuiDialog-container': { position: 'relative' },
        '.MuiPaper-root': { position: 'initial' },
      }}
      slotProps={{ backdrop: { style: { background: '#000000b2' } } }}
      maxWidth='md'
      open={isModalOpen}
      onClose={onCloseModal}
      closeAfterTransition
    >
      <AlertSnackbar
        text={'Something went wrong with the screenshot'}
        open={isError}
        handleClose={() => setIsError(false)}
      />
      <IconButton
        aria-label='close'
        onClick={onCloseModal}
        sx={{ position: 'absolute', right: 8, top: 8 }}
      >
        <Close sx={{ color: (theme) => theme.palette.grey[500] }} />
      </IconButton>
      <Stack sx={{ width: 900 }} alignItems='center' m='0 auto'>
        <Typography
          fontSize={24}
          position='absolute'
          top={20}
          sx={{ p: '5px 10px', borderRadius: '5px', background: 'white' }}
        >
          {timelineLabel(
            convertMillisecondsToSeconds(
              +screenshotClocks[selectedScreenshot - 1]?.append - stream.videoStartClock
            )
          )}
        </Typography>
      </Stack>
      <Image
        width='100%'
        src={src}
        onError={() => setIsError(true)}
        onLoad={() => setIsError(false)}
      />
      {selectedScreenshot > 1 && (
        <IconButton
          onClick={() => setSelectedScreenshot((prev) => prev - 1)}
          sx={{ ...arrowStyle, left: 8 }}
        >
          <ChevronLeftOutlined
            fontSize='small'
            sx={{ color: (theme) => theme.palette.grey[500] }}
          />
        </IconButton>
      )}
      {selectedScreenshot < screenshotClocks.length && (
        <IconButton
          sx={{ ...arrowStyle, right: 8 }}
          onClick={() => setSelectedScreenshot((prev) => prev + 1)}
        >
          <ChevronRightOutlined
            fontSize='small'
            sx={{ color: (theme) => theme.palette.grey[500] }}
          />
        </IconButton>
      )}
      <ImagePagination
        page={selectedScreenshot}
        totalPages={screenshotClocks.length}
        onPageChange={setSelectedScreenshot}
      />
    </Dialog>
  );
};
